import AppDispatcher from "../dispatcher/AppDispatcher";

import AppConstants from "../constants/AppConstants";

import Api from "../utils/Api";

// SettingActions
export default
{
	async updateUserProfile(property, value)
	{
		AppDispatcher.handleAction({
			actionType: AppConstants.USERPROFILE_UPDATE_PENDING
		});

		try
		{
			const userProfile = await Api.updateUserProfile(property, value);

			AppDispatcher.handleAction({
				actionType: AppConstants.USERPROFILE_UPDATE_SUCCESS,
				userProfile
			});

			return userProfile;
		}
		catch(message)
		{
			console.error(message);

			AppDispatcher.handleAction({
				actionType: AppConstants.USERPROFILE_UPDATE_FAILURE,
				message
			});
		}
	}
};



// WEBPACK FOOTER //
// ./Components/actions/SettingActions.jsx